<script>
/* globals window */
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';
import axios from 'axios';
import BaseForm from './base-form';

export default {

    data: function() {
        return {
            ...BaseForm.data(),
            analytics: true,
            persistents: {
                selected_metros: [],
                selected_regions: [],
                selected_communities: [],
                selected_residences: [],
                selected_homes: [],
            }
        }
    },

    props: [
        'openModal',
        'closeModal',
        'isModalOpen',
        'metroId',
        'regionId',
        'communityId',
        'residenceId',
        'homeId',
    ],

    mounted() {
        if (this.metroId) {
            this.persistents.selected_metros = [this.metroId];
        }
        if (this.regionId) {
            this.persistents.selected_regions = [this.regionId];
        }
        if (this.communityId) {
            this.persistents.selected_communities = [this.communityId];
        }
        if (this.residenceId) {
            this.persistents.selected_residences = [this.residenceId];
        }
        if (this.homeId) {
            this.persistents.selected_homes = [this.homeId];
        }
        this.boot();
    },

    computed: {
        ...BaseForm.computed
    },

    watch: {
        ...BaseForm.watchers,
        'fields.selected_communities': function(val) {
            if (!val) {
                return;
            }
            this.getRelatedCommunityData(val);
        }
    },

    methods: {
        ...BaseForm.methods,
        async getRelatedCommunityData(communityId) {
            try {
                const response = await axios.get(`/api/form-data-for-community/${communityId}`);
                if (response && response.data && response.status === 200) {
                    if (response.data.communityId) {
                        this.persistents.selected_communities = [response.data.communityId];
                    }
                    if (response.data.regionId) {
                        this.persistents.selected_regions = [response.data.regionId];
                    }
                    if (response.data.metroId) {
                        this.persistents.selected_metros = [response.data.metroId];
                    }
                }
            } catch (error) {
                console.error(error);
            }
        },

        submit(event) {
            this.beforeSubmit().then((token) => {
                this.form.post(event.target.action, {
                        ...this.fields, ...this.persistents,
                        'g-recaptcha-response': token
                    })
                    .then((result) => this.success(result, event))
                    .catch(() => this.failure());
            });
        },
    }
};

</script>



// WEBPACK FOOTER //
// resources/components/forms/realtor-form.vue